export const LISTING_TYPE_FIRST_COME_FIRST_SERVED = 'First Come, First Served'
export const PROGRAM_TYPE_INCLUSIONARY_RENTAL = 'IH-RENTAL'

export const UNIT_STATUS_AVAILABLE = 'Available'

export const CONTACT_INFO_UPDATED =
  'Applicant changed their contact info. Use updated details for future outreach.'
export const CONTACT_INFO_UPDATED_BADGES_FLAG = 'temp.webapp.newAccountLayout'
